import * as React from 'react';
import styled from '@emotion/styled';

export interface FieldProps {
  label?: React.ReactNode;
  hint?: React.ReactNode;
  error?: React.ReactNode;
  htmlFor?: string;
  children?: React.ReactNode;
  className?: string;
}

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;
const LabelText = styled.label`
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  color: ${({ theme }) => theme.color.fg.default};
`;
const Hint = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.fg.subtle};
`;
const Err = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.danger};
`;

/** Lumen field — label + control + hint/error stack. Error takes priority over hint. */
export function Field({ label, hint, error, htmlFor, children, className }: FieldProps) {
  return (
    <Wrap className={className}>
      {label && <LabelText htmlFor={htmlFor}>{label}</LabelText>}
      {children}
      {error ? <Err>{error}</Err> : hint ? <Hint>{hint}</Hint> : null}
    </Wrap>
  );
}
